import { render, staticRenderFns } from "./ViewApprovedPpaValue.vue?vue&type=template&id=1d28b514&scoped=true"
import script from "./ViewApprovedPpaValue.vue?vue&type=script&lang=js"
export * from "./ViewApprovedPpaValue.vue?vue&type=script&lang=js"
import "./ViewApprovedPpaValue.vue?vue&type=style&index=0&id=1d28b514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28b514",
  null
  
)

export default component.exports